/**
 * @file NotFound.style.js
 * Exports NotFound component styles.
 */

export default theme => ({
  wrapper: {
    background: theme.palette.background.default,
    height: '100vh',
    maxHeight: '100%'
  },
  text: {
    paddingTop: 200,
    textAlign: 'center'
  }
});



// WEBPACK FOOTER //
// ./src/pages/NotFound/NotFound.style.js